import { CHINA_SIMILAR_LANGUAGES } from '@/constants/language'

export function getDefaultLanguageCode(
  language: string,
  toLower: boolean = false,
) {
  let result: string

  switch (language) {
    case 'en':
      result = 'en-US'
      break
    case 'ko':
      result = 'ko-KR'
      break
    case 'fr':
      result = 'fr-FR'
      break
    // case "zh":
    //   result = "zh-zho";
    //   break;
    case 'zh':
      result = 'cmn-CN'
      break
    case 'ja':
      result = 'ja-JP'
      break
    case 'de':
      result = 'de-DE'
      break
    case 'es':
      result = 'es-ES'
      break
    default:
      result = language
  }

  if (toLower) {
    return result.toLowerCase()
  }
  return result
}

export const isSimilarChineseLanguage = (language: string) => {
  return (CHINA_SIMILAR_LANGUAGES as readonly string[]).includes(
    language.split('-')[0],
  )
}

export const isSameLanguage = (
  fromLanguage: string,
  detectedLanguage: string,
  /**
   * exact가 true일 경우, 언어 코드가 정확히 일치해야함
   */
  exact?: boolean,
) => {
  if (!fromLanguage || !detectedLanguage) {
    return false
  }

  /**
   * exact가 true일 경우, 언어 코드가 정확히 일치해야함
   */
  if (exact) {
    return fromLanguage === detectedLanguage
  }

  return (
    fromLanguage.split('-')[0] === detectedLanguage.split('-')[0] ||
    (isSimilarChineseLanguage(detectedLanguage) &&
      isSimilarChineseLanguage(fromLanguage))
  )
}

export const isMatchLanguage = (
  fromLanguage: string,
  detectedLanguage: string,
) => {
  /**
   * 둘 중 하나라도 multi인 경우 항상 허용
   */
  if (fromLanguage === 'multi' || detectedLanguage === 'multi') {
    return true
  }

  return isSameLanguage(fromLanguage, detectedLanguage)
}


export const getBrowserLanguageCode = () => {
  if(navigator.language) {
    return navigator.language;
  }
  return "en-US";
}

export const getApiLanguageCode = (langCode?: string) => {
  langCode = langCode || getBrowserLanguageCode();
  if(langCode === "cmn-CN") {
    return "zh";
  }
  let lang = langCode.split("-")[0];
  switch(lang) {
    case "zh":
    case "en":
    case "ko":
      return lang;
    default:
      return "en";
  }
}